import type { ActionReducerMap } from '@ngrx/store';

import { webReducer } from './web/web.reducer';
import type { WebState } from './web/web.state';

export interface AppState {
  web: WebState;
}

export const REDUCERS: ActionReducerMap<AppState> = {
  web: webReducer,
};
